import { SUBMENU_PARAM_ARCHIVE_VALUE } from '../../../../../constants/route'
import { DESC_ORDER_SYMBOL } from '../../../../../constants/sort'
import { isValueNumberType } from '../../../../../utils/common'
import { CONTRACT_COLUMN_NAME } from '../../../../EntityTab'
import {
  CONTRACT_COLUMN_CONFIG,
  CONTRACT_DWELLER_VISIBLE_COLUMNS,
  CONTRACT_VIEWER_ROLE,
} from '../ProfileContractsTabInhabitant.constants'

function getContractSortValue(contract, field) {
  switch (field) {
    case CONTRACT_COLUMN_NAME.Flat:
      return contract.flat?.number
    case CONTRACT_COLUMN_NAME.Building:
      return contract.building?.title
    case CONTRACT_COLUMN_NAME.Category:
      return contract.category?.value
    case CONTRACT_COLUMN_NAME.PropertyShare:
      return contract.property_share?.share
    case CONTRACT_COLUMN_NAME.Landlords:
      return contract.landlords?.length ?? 0
    case CONTRACT_COLUMN_NAME.Dwellers:
      return contract.dwellers?.length ?? 0
    default:
      return contract[field]
  }
}

function compareValues(a, b) {
  if (a == null && b == null) {
    return 0
  }

  if (a == null) {
    return -1
  }

  if (b == null) {
    return 1
  }

  if (isValueNumberType(a) && isValueNumberType(b)) {
    return a - b
  }

  return String(a).localeCompare(String(b))
}

export function getSortedContracts(contracts, ordering) {
  const orderingList =
    ordering?.length > 0 ? ordering : [`${DESC_ORDER_SYMBOL}updated`]

  return [...contracts].sort((left, right) => {
    for (const entry of orderingList) {
      const isDesc = entry.startsWith(DESC_ORDER_SYMBOL)
      const field = isDesc ? entry.slice(DESC_ORDER_SYMBOL.length) : entry

      const result = compareValues(
        getContractSortValue(left, field),
        getContractSortValue(right, field)
      )

      if (result !== 0) {
        return isDesc ? -result : result
      }
    }

    return 0
  })
}

export function getContractsForSubTab(contracts, activeSubTab) {
  const isArchive = activeSubTab === SUBMENU_PARAM_ARCHIVE_VALUE

  return contracts.filter(contract => Boolean(contract.archived) === isArchive)
}

export function getPagedContracts(contracts, { page, pageSize }) {
  const start = (page - 1) * pageSize

  return contracts.slice(start, start + pageSize)
}

export function getContractsColumns(viewerRole) {
  const isDwellerViewer = viewerRole === CONTRACT_VIEWER_ROLE.Dweller

  return Object.fromEntries(
    Object.entries(CONTRACT_COLUMN_CONFIG).map(([name, config]) => [
      name,
      {
        ...config,
        name,
        ordering_field: name,
        visible: isDwellerViewer
          ? CONTRACT_DWELLER_VISIBLE_COLUMNS.includes(name)
          : true,
      },
    ])
  )
}
